import { PageAreaContext } from 'global/cnr/contexts/PageAreaContext'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { useRenders } from 'global/cnr/contexts/useHelpers/useRenders'
import { uniqueKey } from 'global/common/keys'
import { gEnums } from 'global/enums/globalEnums'
import { PageItem_withProvider } from 'global/page/PageItem'
import _ from 'lodash'
import { useContext, useMemo } from 'react'
import { SwiperSlide } from 'swiper/react'
import { Swiper_Any } from './Swiper_Any'
import { _swiperMenuTypes } from './SwiperMenu'

export const Swiper_PageArea = ({
  swipeContentType,
  swiperMenuType = _swiperMenuTypes.menu,
  applyFade = false,
}) => {

  useRenders('Swiper_PageArea', true, true)

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};
  const { paps_state, page_state } = states ?? {};
  const { viewPathKey } = paps_state ?? {};
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { layout } = aps_page ?? {}
  const { layoutType } = layout ?? {}

  const pageAreaContext = useContext(PageAreaContext)
  const { pageArea_state } = pageAreaContext ?? {}
  const { pageItemsActive, pageData } = pageArea_state ?? {}

  const { slides, menuItems } = useMemo(() => {

    if (swipeContentType !== gEnums.swipeContentTypes.pageAreaContent || _.isEmpty(pageItemsActive)) return []

    let _pageItemActive = pageItemsActive

    if (!_.isEmpty(pageData) && pageItemsActive && layoutType === gEnums.layoutTypes.swipeableHidden) {
      _pageItemActive = _.omitBy(_pageItemActive, (val, key) => {
        return pageData?.[key]?.count === 0
      })
    }

    const sorted = _.sortBy(_pageItemActive, 'position')

    const _slides = _.map(sorted, (csi, csiKey, idx) => (
      <SwiperSlide
        key={uniqueKey('sipi', csi.key)}
        className={`sst-${csi.key}`}>
        {/* <div>{csi.key}</div> */}
        <PageItem_withProvider
          uivi={csi.key}
          tabIndex={idx}
          returnCount={true}
          from="spa"
          inSwiper={true}
          isMounted={true} // or lazy logic here
        />
      </SwiperSlide>
    ))
    return { slides: _slides, menuItems: sorted }
  }, [pageItemsActive, pageData, swipeContentType])

  return (
    <Swiper_Any
      swKey={viewPathKey}
      menuItems={menuItems}
      swipeContentType={swipeContentType}
      swiperMenuType={swiperMenuType}
      isChild={false}
      applyFade={applyFade}
      slides={slides}
      showButtons={true}
    />

  )
}